import React, { useState, useEffect, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { Modal, Paper, IconButton, Button } from "@material-ui/core";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import CancelIcon from "@material-ui/icons/Cancel";
import { CircularProgress } from "@material-ui/core";
import { format } from "date-fns";

import { Context as AuthContext } from "../context/auth.context.js";

import LoginHistory from "../pages/LoginHistory";

const WelcomeBar = (props) => {
  const [title, setTitle] = useState();
  const [loginColor, setLoginColor] = useState("white");
  const [open, setOpen] = React.useState(false);
  const { state } = useContext(AuthContext);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isIpadProSmall = useMediaQuery({ query: "(max-width: 1400px" });

  const getTitle = () => {
    switch (props.selectedRoute) {
      case "/invoices":
        setTitle(`Hello, ${state.firstName}!`);
        return;
      case "/history":
        setTitle("Payment History");
        return;
      case "/wallet":
        setTitle("My Wallet");
        return;
      case "/wallet/addPaymentMethod":
        setTitle("Back to Wallet");
        return;
      default:
        return;
    }
  };

  function handleCloseModal() {
    setOpen(false);
  }

  useEffect(() => {
    getTitle();
  });

  return (
    <div
      style={{
        ...styles.container,
        height: isTabletOrMobile ? 60 : 90,

        background: `linear-gradient(to right,${props.theme.palette.primary.main},${props.theme.palette.welcomeBar.right})`,
      }}
    >
      <div
        style={
          !isTabletOrMobile
            ? {
                ...styles.content,
                paddingLeft: isIpadProSmall ? 25 : 0,
                paddingRight: isIpadProSmall ? 25 : 0,
              }
            : {
                ...styles.content,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: isTabletOrMobile
                  ? "space-between"
                  : "flex-start",
                paddingLeft:
                  props.selectedRoute === "/wallet/addPaymentMethod" ? 10 : 25,
                paddingRight: 25,
                height: 60,
              }
        }
      >
        {props.selectedRoute === "/wallet/addPaymentMethod" ? (
          <Link
            to={{
              pathname: "/wallet",
            }}
            style={{ outline: "none", textDecoration: "none" }}
          >
            <Button
              startIcon={<ChevronLeft color={"white"} />}
              style={{ color: "white" }}
            >
              {title}
            </Button>
          </Link>
        ) : (
          <h3
            style={{
              ...styles.text,
              fontSize: !isTabletOrMobile ? 30 : 22,
              marginBottom: 0,
              marginTop: 0,
            }}
          >
            {title}
          </h3>
        )}

        {props.selectedRoute === "/invoices" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100%",
              alignItems: "center",
            }}
          >
            {!isTabletOrMobile && (
              <>
                <span style={{ color: "white", fontSize: 16 }}>
                <x-lang>Member since</x-lang>{" "}
                  {state.entryDate ? (
                    format(new Date(state.entryDate), "yyyy")
                  ) : (
                    <CircularProgress size={15} />
                  )}
                </span>
                {/* <div
                  style={{
                    width: 1,
                    height: 20,
                    background: "white",
                    marginLeft: 15,
                    marginRight: 15,
                  }}
                /> */}
              </>
            )}

            {/* <span
              style={{ color: loginColor, fontSize: 16, cursor: "pointer" }}
              onMouseEnter={() => setLoginColor("#ddd")}
              onMouseLeave={() => setLoginColor("white")}
              onClick={() => setOpen(true)}
            >
              Login history
            </span> */}
          </div>
        ) : null}
        {isTabletOrMobile && props.selectedRoute === "/invoices" ? (
          <span style={{ color: "white", fontSize: 16 }}>
            {state.accountNumber}
          </span>
        ) : null}
      </div>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
      >
        <Paper
          elevation={3}
          style={{
            height: 800,
            width: 800,
            background: "white",
            outline: "none",
            borderRadius: 5,
            position: "relative",
          }}
        >
          <IconButton
            style={{ position: "absolute", top: 15, right: 15 }}
            onClick={handleCloseModal}
          >
            <CancelIcon />
          </IconButton>
          <LoginHistory />
        </Paper>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    height: 90,
    maxWidth: 1300,
    width: 1300,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "1.5rem",
    fontFamily: "gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif",
  },
  text: {
    color: "white",
  },
};
export default WelcomeBar;
